import { turnToConfig } from 'init/config'

export function localizedPercentage(num: number, fractionDigits = 1) {
  if (isNaN(num)) {
    return ''
  }
  const options = {
    style: 'percent',
    maximumFractionDigits: fractionDigits,
    minimumFractionDigits: fractionDigits
  }
  return num.toLocaleString(turnToConfig.locale.replace('_', '-'), options)
}

export function localizedNumber(num: number, fractionDigits = 1) {
  if (isNaN(num)) {
    return ''
  }
  const options = {
    maximumFractionDigits: fractionDigits,
    minimumFractionDigits: fractionDigits
  }
  return num.toLocaleString(turnToConfig.locale.replace('_', '-'), options)
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!(webpack)-strip-block!./src/util/localization-utils.ts